module.exports = __webpack_public_path__ + "img/chat-background-pattern.0063c7d.svg";